/**
 * Quien acaba de darse de alta no ve «Bienvenido de nuevo» (08-10-2026, Pablo): su primera
 * pantalla es la bienvenida de /welcome, que llama a noSaludarEnEstaSesion() al montarse para
 * que el saludo del arranque (SplashGate) no salga después en la misma sesión.
 */
let noSaludar = false;

export function noSaludarEnEstaSesion(): void {
  noSaludar = true;
}

export function saludoApagadoEnEstaSesion(): boolean {
  return noSaludar;
}
